import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./GettingHelp.css";

const GettingHelp = () => {
  const form = useRef();
  const [status, setStatus] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "YOUR_SERVICE_ID",
        "YOUR_TEMPLATE_ID",
        form.current,
        "YOUR_PUBLIC_KEY"
      )
      .then(
        () => setStatus("Message sent successfully!"),
        (error) => setStatus("Failed to send message: " + error.text)
      );
  };

  const openMailClient = () => {
    const name = form.current.user_name.value;
    const email = form.current.user_email.value;
    const message = form.current.message.value;

    const subject = encodeURIComponent(`Help Request from Web Form - ${name}`);
    const body = encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`
    );

    window.location.href = `mailto:admin@argyllcommunitycounselling.org.uk?subject=${subject}&body=${body}`;
  };

  return (
    <div className="help-container">
      <h1>Get Help</h1>

      <div>
        <p>
          To get started you can phone us{" "}
          <a className="phone-number" href="tel:07902810552">
            07902810552
          </a>
          <br />
          or you can leave us a message:
        </p>
      </div>

      <form ref={form} className="help-form">
        <label>
          Your Name
          <input type="text" name="user_name" required />
        </label>

        <label>
          Your Email
          <input type="email" name="user_email" required />
        </label>

        <label>
          Message
          <textarea name="message" rows="5" required />
        </label>

        <button type="button" onClick={openMailClient}>
          SEND
        </button>
      </form>

      <div>
        <p>
          Thank you for getting in touch. We will get back to you as soon as we
          can.
        </p>
      </div>

      {status && <p className="form-status">{status}</p>}
    </div>
  );
};

export default GettingHelp;